import { getQueryStringParams } from './utils';
/*eslint no-undef: 0*/
$(function () {
    // ── Off-canvas sidebar (mobile) ────────────────────────────────────────
    // Markup lives in layouts/app.blade.php + partials/menu.blade.php;
    // styling in sass/_responsive.scss. On md+ the sidebar is in-flow and
    // these handlers are harmless no-ops (the toggle is display:none).
    const $leftNav = $('#leftNav');
    const $backdrop = $('.left-nav-backdrop');
    const $toggle = $('.left-nav-toggle');
    const $body = $('body');

    function openLeftNav() {
        $leftNav.addClass('show');
        $backdrop.addClass('show');
        $body.addClass('left-nav-open');
        $toggle.attr('aria-expanded', 'true');
    }

    function closeLeftNav() {
        $leftNav.removeClass('show');
        $backdrop.removeClass('show');
        $body.removeClass('left-nav-open');
        $toggle.attr('aria-expanded', 'false');
    }

    $toggle.on('click', function () {
        if ($leftNav.hasClass('show')) {
            closeLeftNav();
        } else {
            openLeftNav();
        }
    });

    $(document).on('click', '[data-left-nav-close]', closeLeftNav);

    // Tapping a leaf link in the drawer should close it; a dropdown parent
    // should NOT (it just expands its children).
    $leftNav.on(
        'click',
        'a.nav-link:not(.dropdown-toggle), a.dropdown-item',
        function () {
            closeLeftNav();
        },
    );

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $leftNav.hasClass('show')) {
            closeLeftNav();
        }
    });

    // If the viewport grows past the mobile breakpoint while the drawer is
    // open, reset state so the in-flow sidebar isn't stuck with `show` /
    // body scroll-lock.
    let resizeTimer = null;

    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            if (window.innerWidth >= 768 && $leftNav.hasClass('show')) {
                closeLeftNav();
            }
        }, 150);
    });
    // ──────────────────────────────────────────────────────────────────────

    // ── Responsive tables ──────────────────────────────────────────────────
    // 41 views render `<table class="table">` with no responsive wrapper,
    // so wide tables overflow the viewport on phones. Wrap them here instead
    // of editing every template. Bootstrap's `.table-responsive-md` only
    // applies `overflow-x:auto` below 768px — on desktop it's an inert div,
    // so nothing inside a table (e.g. a cell dropdown) can be clipped.
    //
    // Vue components (dynamically imported) render their tables well after
    // this handler runs, so a MutationObserver re-applies the wrap whenever
    // new nodes land under #app. Idempotent: a table already inside a
    // responsive wrapper (hand-written or ours) is skipped.
    function wrapResponsiveTables(root) {
        const scope = root && root.querySelectorAll ? root : document;

        // If Vue tore down and re-created a table (v-if toggle, list
        // re-render), it goes back into Vue's original parent — outside the
        // wrapper we added — leaving that wrapper empty. Remove orphans so
        // they don't accumulate as stray margin.
        const empties = scope.querySelectorAll('.table-responsive-md:empty');

        for (let e = 0; e < empties.length; e++) {
            empties[e].parentNode.removeChild(empties[e]);
        }

        const tables = scope.querySelectorAll('table.table');

        for (let i = 0; i < tables.length; i++) {
            const table = tables[i];
            const parent = table.parentNode;

            // Skip tables already in any responsive wrapper (Bootstrap's
            // `.table-responsive` or a breakpoint variant like ours).
            if (
                !parent ||
                /(^|\s)table-responsive(-\w+)?(\s|$)/.test(parent.className)
            ) {
                continue;
            }

            // Leave the print layout and anything in the off-canvas nav alone.
            if (table.closest('.left-nav')) {
                continue;
            }

            const wrapper = document.createElement('div');

            wrapper.className = 'table-responsive-md';
            parent.insertBefore(wrapper, table);
            wrapper.appendChild(table);
        }
    }

    wrapResponsiveTables(document);

    const appRoot = document.getElementById('app');

    if (appRoot && typeof MutationObserver !== 'undefined') {
        let wrapTimer = null;

        const observer = new MutationObserver(function (mutations) {
            // Only bother if an element node was actually added somewhere.
            let added = false;

            for (let i = 0; i < mutations.length && !added; i++) {
                const nodes = mutations[i].addedNodes;

                for (let j = 0; j < nodes.length; j++) {
                    if (nodes[j].nodeType === 1) {
                        added = true;
                        break;
                    }
                }
            }

            if (!added) return;

            // Debounce: Vue renders in bursts.
            clearTimeout(wrapTimer);
            wrapTimer = setTimeout(function () {
                wrapResponsiveTables(appRoot);
            }, 50);
        });

        observer.observe(appRoot, { childList: true, subtree: true });
    }
    // ──────────────────────────────────────────────────────────────────────

    $('#btnPrint').on('click', function () {
        const { origin, pathname } = window.location;

        const qsObj = getQueryStringParams(window.location.search);
        let qs = '';

        // letter filter
        if (qsObj.letter) {
            if (!qs) qs = '?';

            qs += `letter=${qsObj.letter}`;
        }

        // search query
        if (qsObj.q) {
            if (!qs) {
                qs = '?';
            } else {
                qs += '&';
            }

            qs += `q=${qsObj.q}`;
        }

        window.open(`${origin}${pathname}/print${qs}`, 'print-window');
    });

    $('.portal-popup').click(function (e) {
        let trgt = e && e.target && e.target.href;

        // Fallback to currentTarget if target href is not found
        if (!trgt && e && e.currentTarget) {
            trgt = e && e.currentTarget && e.currentTarget.href;
        }

        if (trgt) {
            // const popupWindow = window.open(e.target.href, 'portalPopup', 'height=800,width=900,toolbar=0,menubar=0,location=0');
            const popupWindow = window.open(
                trgt,
                'portalPopup',
                'height=800,width=900',
            );

            if (window.focus) popupWindow.focus();
        }

        return false;
    });
});
